import {AdventureState, user_to_adventure, userToAdventureInput} from "./adventureType";
import {createSlice, PayloadAction} from "@reduxjs/toolkit";
import {UserState} from "../user/userType";

const initialState: AdventureState = {
    adventureId: 0,
    adventureDesc: '',
    adventureName: '',
    user_to_adventure: []
}

export const adventureSlice = createSlice({
    name: 'adventure',
    initialState,
    reducers: {
        setAdventure: (state, action: PayloadAction<AdventureState>) => {
            state.adventureId = action.payload.adventureId
            state.adventureName = action.payload.adventureName
            state.adventureDesc = action.payload.adventureDesc
            state.user_to_adventure = action.payload.user_to_adventure
        },
        setAdventureName: (state, action: PayloadAction<string>) => {
            state.adventureName = action.payload
        },
        setAdventureDesc: (state, action: PayloadAction<string>) => {
            state.adventureDesc = action.payload
        },
        addUserToAdventure: (state, action: PayloadAction<userToAdventureInput>) => {
            state.user_to_adventure.push({
                userToAdventureId: (state.user_to_adventure.length + 1)*-1,
                User: {
                    userId: action.payload.userId,
                    userName: action.payload.userName,
                    Character: [{
                        characterId: action.payload.Character[0].characterId,
                        characterName: action.payload.Character[0].characterName
                    }]
                }
            })
        },
        removeUserFromAdventure: (state, action: PayloadAction<number>) => {
            const deleteIndex = state.user_to_adventure.findIndex((uta: user_to_adventure) => uta.userToAdventureId === action.payload);
            state.user_to_adventure.splice(deleteIndex, 1);
        }
    }
})

export const {
    setAdventure,
    setAdventureName,
    setAdventureDesc,
    addUserToAdventure,
    removeUserFromAdventure
} = adventureSlice.actions
export default adventureSlice.reducer